<template>
  <div class="manage-main-box">
    <Bread :breadConfig="breadConfig" />
    <div class="eol-container-box">
      <div class="search-all-box">
        <a-form-model layout="inline" ref="ruleForm" :model="form">
          <a-form-model-item prop="complete_type">
            <a-select v-model="form.complete_type" placeholder="作业提交形式" style="width: 150px" class="multiple-select" dropdownClassName="multipleDrop">
              <a-select-option v-for="(item, index) in completeArr " :key="index" :value="item.id">{{ item.name }}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item prop="work_type">
            <a-select v-model="form.work_type" placeholder="请选择作业类型" style="width: 150px" class="multiple-select" dropdownClassName="multipleDrop">
              <a-select-option v-for="(item, index) in workArr" :key="index" :value="item.id">{{ item.name }}</a-select-option>
            </a-select>
          </a-form-model-item>

          <a-form-model-item prop="name">
            <a-input v-model="form.name" class="search-input" placeholder="请输入作业提交人姓名"></a-input>
          </a-form-model-item>

          <a-form-model-item prop="term">
            <a-select placeholder="请选择实践学期" style="width: 150px" class="multiple-select" dropdownClassName="multipleDrop" v-model="form.term">
              <a-select-option v-for="(item, index) in activityTerm" :key="index" :value="item.key">{{ item.value }}</a-select-option>
            </a-select>
          </a-form-model-item>
        
          <a-form-model-item prop="course_id">
            <a-select placeholder="请选择实践课程" style="width: 150px" class="multiple-select" dropdownClassName="multipleDrop" v-model="form.course_id">
              <a-select-option v-for="(item, index) in trainCourse" :key="index" :value="item.id">{{ item.name }}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item prop="class_id">
            <a-select show-search notFoundContent="暂无匹配班级" option-filter-prop="children" placeholder="请选择实践班级" style="width: 150px" class="multiple-select" dropdownClassName="multipleDrop" v-model="form.class_id">
              <a-select-option v-for="(item, index) in activityClass" :key="index" :value="item.id">{{ item.name }}</a-select-option>
            </a-select>
          </a-form-model-item>

          <a-form-model-item prop="teacher_name">
            <a-input style="width:160px" class="search-input" placeholder="请输入负责教师" v-model="form.teacher_name"></a-input>
          </a-form-model-item>
          <a-form-model-item>
            <a-button class="search-btn" type="primary" @click="onSearch">搜索</a-button>
            <a-button class="reset-btn" @click="resetForm">重置</a-button>
          </a-form-model-item>
        </a-form-model>
      </div>

      <div class="table-all-box">
        <a-table :columns="columns" :data-source="tableData" :bordered="false" size="small" rowKey="id" :pagination="false">
          <template slot="complete_type" slot-scope="text, scope">
            <span :class="['type-icon', scope.complete_type == 2 ? 'twin': '' ]"></span>{{scope.complete_type == 1 ?  '个人' : '小组'}}完成
          </template>
          <template slot="work_type" slot-scope="text, scope">
            {{scope.work_type == 1 ?  '大学生微电影' : '大学生讲思政课'}}
          </template>
          <template slot="cases_attachments" slot-scope="text, scope">
            <template v-for="item, index in scope.cases_attachments">
              <div v-if="item.type == 3"  :key="index" @click="previewRes(item)" class="link-name">{{item.filename}}.{{item.file_format}}
                <div v-if="item.covert_status == 3" class="file-error">文件异常</div>
              </div>
            </template>
          </template>
          <template slot="action" slot-scope="row, scope">
            <a-button type="link" @click="previewOption(scope)">案例推优</a-button>
          </template>
        </a-table>

        <a-pagination class="school-pagination" v-model="page" :total="totalNum" @change="pageChange" show-less-items />
      </div>
    </div>

    <component :is="dialogConfig.name" :dialogConfig="dialogConfig"></component>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import Bread from "../../../components/school/Bread.vue";
import CommonModal from "../../../components/CommonModal";
export default {
  components: {
    PreviewPdf: () => import('../../../components/PreviewPdf'),
    PlayBox: () => import('../../../components/PlayBox'),
    Bread, 
    CommonModal,
  },
  data () {
    return {
      school_code: localStorage.getItem("schoolCode"),
      breadConfig: [
        { name: "实践案例" },
        { name: "案例台账" },
      ],
      dialogConfig: {
        type: "",
        name: "",
        fileId: "",
        path: "",
        title: "",
      },
      page: 1,
      size: 10,
      totalNum: 0,
      tableData: [],
      form: {
        complete_type: undefined,
        work_type: undefined,
        name: undefined,
        term: undefined,
        course_id: undefined,
        class_id: undefined,
        teacher_name: undefined,
      },
      completeArr: [
        { id: 1, name: '个人完成' },
        { id: 2, name: '小组完成' },
      ],
      workArr: [
        { id: 1, name: '大学生微电影' },
        { id: 2, name: '大学生讲思政课' },
      ],
      columns: [
        {
          title: "作业提交形式",
          dataIndex: "complete_type",
          scopedSlots: { customRender: 'complete_type' },
          width: '80px',
        },
        {
          title: "作业提交人",
          dataIndex: "created_name",
        },
        {
          title: "所属班级",
          dataIndex: "class_name",
          width: '80px',
        },
        {
          title: "负责教师",
          dataIndex: "teacher_name",
        },
         {
          title: "作业类型",
          dataIndex: "work_type",
          scopedSlots: { customRender: 'work_type' },
        },
        {
          title: "实践基地",
          dataIndex: "hub",
        },
        {
          title: "实践学期",
          dataIndex: "term_name",
        },
        {
          title: "实践课程",
          dataIndex: "course_name",
        },
        {
          title: "作业附件",
          dataIndex: "cases_attachments",
          scopedSlots: { customRender: 'cases_attachments' },
        },
        {
          title: "提交时间",
          dataIndex: "updated_at",
          width: '120px',
        },
        {
          title: "操作",
          dataIndex: "action",
          scopedSlots: { customRender: 'action' },
          align: 'center',
        },
      ],
    };
  },
  computed: {
    ...mapState({
      activityTerm: state => state.teachEvent.activityTerm,
      trainCourse: state => state.teachEvent.trainCourse,
      activityClass: state => state.teachEvent.activityClass,
    }),
  },
  mounted () {
    // 获取学期数据
    this.getActivityTerm()
    // 获取实验课程
    this.getTrainCourse()
    // 获取实践班级列表
    this.getActivityClass({page: 1, size: 999})

    this.getTableList()
  },
  methods: {
    ...mapActions(["getActivityTerm", "getTrainCourse", "getActivityClass", "getCasesLedgerList"]),
    // filterOption(input, option) {
      // return (
      //   option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      // );
      // return true;
    // },
    getTableList () {
      let params = {
        id: 't007',
        data: {
          page: this.page,
          size: this.size,
          term: this.form.term,
          complete_type: this.form.complete_type,
          work_type: this.form.work_type,
          name: this.form.name,
          course_id: this.form.course_id,
          class_id: this.form.class_id,
          teacher_name: this.form.teacher_name,
        }
      };
      this.getCasesLedgerList(params).then((res) => {
        if (res.code == "0000" && res.data) {
          this.tableData = res.data.items;
          this.totalNum = res.data.total;
          // console.log(res.data)
        }
      });
    },
    onSearch () {
      this.page = 1;
      this.total = 0;
      this.getTableList();
    },
    pageChange (val) {
      this.page = val;
      this.total = 0;
      this.getTableList();
    },
    resetForm () {
      this.$refs.ruleForm.resetFields();
      this.onSearch()
    },
    // 进入案例推优
    previewOption (item) {
      console.log(item)
      this.$router.push({ path: `/${this.school_code}/school/case/casepushform`,  
        query: {
          work_id: item.id, // 作业id
          id: item.activity_id, // 活动id
        }
      });
    },
    // 预览资源
    previewRes (item) {
      if (item.type != 1 && item.type != 2 && item.covert_status == 1) return this.$message.info("请等待转码完成后预览")
      if (item.type != 1 && item.type != 2 && item.covert_status == 3) return this.$message.info("转码失败")
      this.dialogConfig.title = item.filename + "." + item.file_format
      this.dialogConfig.type = item.type
      if (item.type == 1 || item.type == 2 || item.type == 4) {
        // 图片/音频/文档
        this.dialogConfig.path = item.view_url;
        this.dialogConfig.name = 'PreviewPdf';
      } else {
        // 视频
        this.dialogConfig.fileId = item.file_id
        this.dialogConfig.name = 'PlayBox';
      }
    },
  },
};
</script>

<style lang="less" scoped>
.link-name {
  font-size: 14px;
  color: #b84b3c;
  cursor: pointer;
}
.file-error {
  width: 80px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  background: #B84B3C;
  border-radius: 4px;
  font-weight: bold;
  font-size: 11px;
  color: #FFECEE;
  display: inline-block;
  margin-left: 4px;
  &::before {
    content: "";
    display: inline-block;
    width: 12px;
    height: 12px;
    vertical-align: -2px;
    margin: 0 5px 0 0;
    background: url("../../../assets/image/common/error-icon.png") no-repeat center / cover;
  }
}
</style>